import React from 'react';
import Colors from '../../assets/Colors';
import { useDesktopOrLaptop } from "../../services/useDesktopOrLaptop";

const CheckBoxComp = ({ name, label, checked = false, onChecked, margin, }) => {
    const { smFontSize, mdFontSize, isdesktop } = useDesktopOrLaptop();
    const styles = {
        input: {
            minWidth: "20px",
        },
        inputLable: {
            fontFamily: "Poppins",
            fontWeight: "500",
            color: Colors.fontGreyLight,
            fontSize: mdFontSize,
            marginLeft: "15px"
        },
        inputForEdit: {
            width: "100%",
            padding: "6px 4px",
            display: "flex",
            margin: margin ? margin : undefined
        },
    };

    const onChange = (e) => onChecked({ name, value: e.target.checked })

    return (
        <div style={styles.inputForEdit}>
            { checked 
                ? <input style={styles.input} name={name} checked={checked} onChange={onChange} type="checkbox" /> 
                : <input style={styles.input} name={name} onChange={onChange} type="checkbox" />
            }
            <label style={styles.inputLable}>{label}</label>
        </div>
    )
}

export default CheckBoxComp